import { Identify, identify, init, setGroup, setUserId, track } from '@amplitude/analytics-browser';
import Config from './Config';
const setUserProperties = ({ email, teamName }) => {
    const IdentifyObj = new Identify();
    setUserId(email);
    setGroup('organization_id', teamName.toString().toLowerCase());
    IdentifyObj.set('organization_id', teamName.toString().toLowerCase());
    identify(IdentifyObj);
};
const trackEvent = ({ event, eventProperties, env = 'performance' }) => {
    if (window.Cypress || !Config.amplitudeAPIEndpoint)
        return null;
    init(env == 'performance' ? Config.amplitudeKey : Config.amplitudeKeyCulture, undefined, {
        serverUrl: Config.amplitudeAPIEndpoint + '/2/httpapi'
    });
    track(event, eventProperties);
};
export { trackEvent, setUserProperties };
